import React from 'react';
import {Box} from 'reactjs-admin-lte';
import FontAwsome from 'react-fontawesome';
import {Col, Row} from 'react-bootstrap';

export default ({loading = true, delivering = {}}) => {
  return (<div>
    <Box loading={loading}>
      <Box.Header>
        <Box.Title border={true}>
          <FontAwsome className="text-blue"
                      name="check-square-o" /> รับรถเข้าซ่อม
        </Box.Title>
      </Box.Header>
      <Box.Body>

        {/*Row 1*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">วันที่ลูกค้ามารับรถ</label>
          </Col>
          <Col sm={2}>
            <input className="form-control" disabled
                   value={delivering.delivering_date} />
          </Col>
          <Col sm={2}>
            <input className="form-control" disabled
                   value={delivering.delivering_time} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">ชื่อผู้มารับรถ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.delivering_name} />
          </Col>
        </Row>

        {/*Row 2*/}
        <Row className="form-group">
          <Col sm={2}>
            <label
                className="control-label">เกี่ยวข้องกับผู้เอาประกันภัย</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.relationship} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">ที่อยู่</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.address} />
          </Col>
        </Row>

        {/*Row 3*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ผลการซ่อมรถ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.result} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">บัตรประจำตัวประชาชน</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.identity_no} />
          </Col>
        </Row>

        {/*Row 4*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">อุปกรณ์/ทรัพย์สินภายในรถ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.asset} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">เบอร์โทรศัพท์</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.tel} />
          </Col>
        </Row>

        {/*Row 5*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ชื่อเจ้าหน้าที่ส่งมอบรถ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.delivered_by} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">เบอร์ติดต่ออื่น</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.other_tel} />
          </Col>
        </Row>

        {/*Row 6*/}
        <Row className="form-group">
          <Col sm={2}>
          </Col>
          <Col sm={4}>
          </Col>
          <Col sm={2}>
            <label
                className="control-label">เบอร์สำหรับส่ง SMS </label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={delivering.tel_forsms} />
          </Col>
        </Row>
      </Box.Body>
    </Box>
  </div>);
};


// WEBPACK FOOTER //
// ./src/view/workdoc/preview/components/PreviewDeliver.js